// colors.js
export const themes = {
  light: {
    primary: '#00A2E8', // Main blue color
    primaryDark: '#00395a', // Dark blue for hover states
    secondary: '#0085C3', // Darker blue for hover states
    accent: '#4DC3FF', // Lighter blue for accents
    text: '#333333', // Main text color
    lightText: '#666666', // Secondary text color
    background: '#FFFFFF', // White background
    lightBackground: '#F5F5F5', // Light gray background
    cardBackground: '#FFFFFF',
    border: '#E0E0E0',
    shadow: 'rgba(0, 0, 0, 0.1)',
  },
  dark: {
    primary: '#4DC3FF',
    primaryDark: '#00A2E8',
    secondary: '#0085C3',
    accent: '#00A2E8',
    text: '#FFFFFF',
    lightText: '#CCCCCC',
    background: '#1A1A1A',
    lightBackground: '#2D2D2D',
    cardBackground: '#2D2D2D',
    border: '#404040',
    shadow: 'rgba(0, 0, 0, 0.3)',
  }
};

// For backward compatibility
export const colors = themes.light;
   